import React from 'react';
import { Outlet } from 'react-router-dom';
// import { Container } from 'react-bootstrap';

export default class ContentLayout extends React.Component<any, any> {

    render() {
        return (
            <>
                {/* <Container fluid> */}
                    <Outlet />
                {/* </Container> */}
            </>
        )
    }
}